import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import * as RUITooltip from '@radix-ui/react-tooltip';

import classes from './styles.module.scss';

const Tooltip = (props) => {
    const { children, content, disabled, open, side, align, variant, hideArrow, delayDuration, maxWidth } = props;

    if (disabled || !content) {
        return children;
    } else {
        return (
            <RUITooltip.Provider delayDuration={delayDuration}>
                <RUITooltip.Root open={open}>
                    <RUITooltip.Trigger asChild>{children}</RUITooltip.Trigger>
                    <RUITooltip.Portal>
                        <RUITooltip.Content sideOffset={5} side={side} align={align}>
                            <div
                                className={clsx(classes.contentWrapper, {
                                    [classes.lightContentWrapper]: variant === 'light',
                                })}
                                style={{
                                    maxWidth,
                                }}
                            >
                                {content}
                            </div>
                            {!hideArrow && (
                                <RUITooltip.Arrow
                                    className={clsx(classes.arrow, { [classes.lightArrow]: variant === 'light' })}
                                />
                            )}
                        </RUITooltip.Content>
                    </RUITooltip.Portal>
                </RUITooltip.Root>
            </RUITooltip.Provider>
        );
    }
};

Tooltip.defaultProps = {
    disabled: false,
    open: undefined,
    side: 'bottom',
    align: 'center',
    variant: 'dark',
    content: undefined,
    hideArrow: false,
    delayDuration: 0,
    maxWidth: undefined,
};

Tooltip.propTypes = {
    children: PropTypes.element.isRequired,
    disabled: PropTypes.bool,
    open: PropTypes.bool,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    side: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
    variant: PropTypes.oneOf(['light', 'dark']),
    align: PropTypes.oneOf(['center', 'start', 'end']),
    hideArrow: PropTypes.bool,
    delayDuration: PropTypes.number,
    maxWidth: PropTypes.number,
};

export default Tooltip;
